import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  login,
  deleteErrorLogin,
} from '../../actions/security';
import {
  Avatar,
  Button,
  CssBaseline,
  Typography,
  Container,
  Grid,
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import InputField from '../Reusable/InputField';
import { Link, useHistory } from 'react-router-dom';
import { LoginForm } from '../../enums/LoginEnums';
import { handleServerErrorMessage } from '../../utils';
import ModalForChangePasswordInfo from './ModalForChangePasswordInfo';

const Login = () => {
  let history = useHistory();
  const dispatch = useDispatch();
  const securityReducer = useSelector((state) => state.security);
  const { validToken, error } = securityReducer;

  const roleId = securityReducer?.loggedUser?.role?.id;
  const isDriver = roleId === 3;

  useEffect(() => {
    if (validToken) {
      if (isDriver) {
        history.push('/travelOrder');
      } else {
        history.push('/');
      }
    }
  }, [validToken, roleId, history]);

  const [loginRequestData, setLoginRequestData] = useState({
    username: '',
    password: '',
  });


  const [showChangePasswordModalInfo, setShowChangePasswordModalInfo] =
    useState(false);


  const onChange = (e) => {
    const { name, value } = e.target;
    setLoginRequestData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const showModal = () => {
    setShowChangePasswordModalInfo(true);
  };

  const handlePreviewClose = () => {
    setShowChangePasswordModalInfo(false);
  };

  const handleSubmit = (e) => {
    dispatch(deleteErrorLogin());
    e.preventDefault();
    dispatch(login(loginRequestData));
  };

  return (
    <div className="wrapper-fade-in">
      <Container component="main" maxWidth="xs" className="page-padding-top">
        <CssBaseline />
        <div className="paper-login">
          <Avatar className="avatar-login">
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            {LoginForm.loginFormTitle}
          </Typography>
          <form className="form-login">
            {error?.locked ? handleServerErrorMessage(error?.locked) : null}
            <InputField
              name="username"
              placeholder={LoginForm.loginPlaceholderUername}
              onChange={onChange}
              required
              value={loginRequestData.username}
              error={error?.username}
              autoFocus
            />
            <InputField
              type="password"
              name="password"
              placeholder={LoginForm.loginPlaceholderPassword}
              onChange={onChange}
              required={true}
              value={loginRequestData.password}
              error={error?.password}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className="submit-login mt-4 mb-3"
              onClick={handleSubmit}
            >
              {LoginForm.loginFormSubmitButton}
            </Button>
            <Grid container>
              <Grid item xs>
                <Link to="#" id="changePassword" onClick={() => showModal()}>
                  {LoginForm.loginFormForrgotPasswordLink}
                </Link>
              </Grid>
              <Grid item>
                <Link
                  to="/signUp"
                  variant="body2"
                  className="default-link-style"
                >
                  {LoginForm.loginFormSignUpLink}
                </Link>
              </Grid>
            </Grid>
            <>
              {showChangePasswordModalInfo && (
                <ModalForChangePasswordInfo
                  handleClose={handlePreviewClose}
                  showChangePasswordModalInfo={showChangePasswordModalInfo}
                />
              )}
            </>
          </form>
        </div>
      </Container>
    </div>
  );
};

export default Login;
